import SalesPeriod from './SalesPeriod';

export default SalesPeriod;
